const toSimpleText = (value) => {
  if (value == null) return '';
  return String(value).trim();
};

const pickFirstMessage = (candidates) => {
  for (const candidate of candidates) {
    const text = toSimpleText(candidate);
    if (text) return text;
  }
  return '';
};

export const getUserFriendlyError = (error, fallback = 'Something went wrong.') => {
  const message = pickFirstMessage([
    error?.response?.data?.responseInformation?.responseMessage,
    error?.response?.data?.message,
    error?.response?.data?.error,
    error?.message,
  ]);

  if (message) return message;

  if (error?.response?.status === 0 || toSimpleText(error?.code) === 'ERR_NETWORK') {
    return 'Unable to connect. Please check your internet and try again.';
  }

  return fallback;
};

export const getApiResponseMessage = (response, fallback = 'Something went wrong.') => {
  return (
    pickFirstMessage([
      response?.responseInformation?.responseMessage,
      response?.message,
      response?.error,
    ]) || fallback
  );
};

